<template>
  <div class="order-history-section__box">
    <div class="order-history-section__date-area">
      <div class="order-history-section__date">
        {{ formattedCreatedDate }}
      </div>
    </div>
    <OrderHistoryWishListInfo
      :showable="wishListUser.showable"
      :icon-url="wishListUser.iconUrl"
      :nickname="wishListUser.nickname"
    />
    <div class="order-history-section__ticket-area">
      <div class="order-history-section__ticket">
        <ticket-detail-for-purchase-history
          :link-url="`/items/${itemSkuContent.itemId}/item_skus/${itemSkuContent.itemSkuId}`"
          :image-url="itemSkuContent.imageUrl"
          :item-id="itemSkuContent.itemId"
          :item-name="itemSkuContent.itemName"
          :item-sku-id="itemSkuContent.itemSkuId"
          :item-sku-name="itemSkuContent.itemSkuName"
          :brand-name="itemSkuContent.brandName"
          :is-ticket-expired="false"
          :other-item-sku-contents-count="otherItemSkuContentsCount"
        />
      </div>
    </div>
    <div class="order-history-section__message-wrap-area">
      <div class="order-history-section__message-area message--min">
        <div class="order-history-section__message">
          {{ message }}
        </div>
      </div>
    </div>
    <div class="order-history-section__button-area">
      <div v-if="wishListUser.showable">
        <button
          class="btn-multi btn-multi--top chevron--forward--black order-history-section__button"
          @click="moveOrderDetail"
        >
          詳細を見る
        </button>
        <button
          class="btn-multi btn-multi--bottom chevron--forward--black order-history-section__wish-list-button"
          @click="moveWishList"
        >
          <span class="wish-list-button__nickname">
            {{ wishListUser.nickname }}
          </span>
          <span class="wish-list-button__text">
            さんのほしいものリストを見る
          </span>
        </button>
      </div>
      <button
        v-else
        class="btn-multi btn-multi--single chevron--forward--black order-history-section__button"
        @click="moveOrderDetail"
      >
        詳細を見る
      </button>
    </div>
  </div>
</template>

<script>
import OrderHistoryWishListInfo from './OrderHistoryWishListInfo.vue'
import TicketDetailForPurchaseHistory from '../../../atoms/tickets/TicketDetailForPurchaseHistory.vue'
import dayjs from 'dayjs'

export default {
  components: {
    OrderHistoryWishListInfo,
    TicketDetailForPurchaseHistory
  },
  props: {
    id: {
      type: Number,
      require: true,
      default: 0
    },
    orderCode: {
      type: String,
      require: true,
      default: ''
    },
    message: {
      type: String,
      require: true,
      default: ''
    },
    createdAt: {
      type: String,
      require: true,
      default: ''
    },
    itemSkuContent: {
      type: Object,
      require: true,
      default: () => {}
    },
    itemSkuContentsCount: {
      type: Number,
      require: true,
      default: 1
    },
    wishListUser: {
      type: Object,
      require: true,
      default: () => {}
    },
    isApp: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    formattedCreatedDate() {
      return dayjs(this.createdAt).format('YYYY年M月D日 HH:mm')
    },
    otherItemSkuContentsCount() {
      return this.itemSkuContentsCount - 1
    },
    displayableOtherItemSkuContentsCount() {
      return this.otherItemSkuContentsCount >= 1
    }
  },
  methods: {
    moveOrderDetail() {
      location.href = `/mypage/order_histories/${this.orderCode}`
    },
    moveWishList() {
      if (!this.isApp) {
        dataLayer.push({
          event: 'select_wishlist',
          button: 'order_history'
        })
      } else {
        // eslint-disable-next-line no-undef
        logEvent('select_wishlist', {
          button: 'order_history'
        })
      }
      location.href = this.wishListUser.wishListUrl
    }
  }
}
</script>
<style lang="scss" scoped>
.order-history-section {
  &__box {
    background-color: $white;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
  }

  &__date-area {
    background-color: $white;
  }

  &__date {
    @extend %minimal;
  }

  &__message-area {
    padding: 12px;
    overflow: hidden;
  }

  &__message {
    @extend %minimal;

    overflow: hidden;
    color: $black;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }

  &__wish-list-button {
    display: flex;
  }
}
.wish-list-button {
  &__nickname {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__text {
    padding-right: 6px;
  }
}
</style>
